import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { getLangData, createLink } from '../services/lang';

export default class Footer extends Component {

    render() {

        const langData = getLangData();

        return (
            <footer className="container-fluid border-top py-3 bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                            &#169; 2019-{new Date().getFullYear()} Susanne Klein Estate
                        </div>
                        <div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex justify-content-end">
                            <Link className="mr-2" to={createLink('/contact')} >{langData.contact.header2}</Link>
                            |<Link className="ml-2" to={createLink("/imprint")}>{langData.imprint.header}</Link>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}